exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-bottom {\n  position: absolute;\n  opacity: 1;\n  bottom: 0px;\n  color: rgba(230, 230, 230, 0.8);\n  text-align: center;\n  z-index: 2147483647;\n  -webkit-transition: all 1s ease;\n  transition: all 1s ease;\n  background-color: rgba(0, 0, 0, 0.2);\n  left: 10px;\n}\n\n.player-bar-icons {\n  margin-left: 5px;\n  font-size: 30px;\n  padding: 5px;\n  float: left;\n\n}\n\n.player-bar-icon {\n  margin-right: 10px;\n}\n\n.trailer {\n  position: relative;\n}\n\n#player-div {\n  position: relative;\n}\n\n.seo-tags {\n  display: inline-block;\n  font-size: 15px;\n  font-weight: bolder;\n  background-color: #d50b01;\n  padding: 0px 5px;\n  margin-right: 10px;\n  margin-top: 3px;\n  cursor: pointer;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.seo-tags:hover {\n  background-color: white;\n  color: #d50b01;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/content-detail/content-detail.component.css
// module id = ../../../../../src/app/views/vod/content-detail/content-detail.component.css
// module chunks = main